export const accountancyDefaultNL = {
  id: '5390a68a-6e3a-45a0-bb0f-ce0bc1b72a15',
  identifier: 'accountancy-default',
}
